import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import api from "../Auth/Middleware";
import SnackbarComponent from "../Common/SnackbarComponent";

const QueryForm = () => {
  const [snackbarMsg, setSnackbarMSg] = useState("");
  const [snackbarSevierty, setSnackbarSevierty] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const initialValues = {
    userName: "",
    contact: "",
    query: "",
  };

  const validationSchema = Yup.object().shape({
    userName: Yup.string().required("Name is required"),
    contact: Yup.string().required("Phone number is required"),
    query: Yup.string().required("Query is required"),
  });

  const handleSubmit = async (values, { resetForm }) => {
    if (!validateMobileNumber(values.contact)) {
      setSnackbarOpen(true);
      setSnackbarMSg("Please Enter a valid mobile number");
      setSnackbarSevierty("warning");
    } else {
      try {
        await sessionStorage.setItem("username", values.userName);
        const response = await api.post("Student/AddQuery", values);
        if (response.status === 200) {
          setSnackbarOpen(true);
          setSnackbarMSg(
            `Your Query Submitted Successfull. Our Team will contact you in 48 working hours`
          );
          setSnackbarSevierty("success");
        } else {
          setSnackbarOpen(true);
          setSnackbarMSg(`Something Went Wrong! Please try saving again`);
          setSnackbarSevierty("success");
        }
      } catch (error) {
        setSnackbarOpen(true);
        setSnackbarMSg("API Error Occured");
        setSnackbarSevierty("error");
      }
      console.log("Form submitted with values:", values);
      resetForm();
    }
  };

  const closeSnackbar = () => {
    setSnackbarOpen(false);
  };

  const validateMobileNumber = (mobileNumber) => {
    if (mobileNumber === "") {
      return true;
    }
    const regex = /^[6-9]\d{9}$/;
    return regex.test(mobileNumber);
  };

  return (
    <>
      <SnackbarComponent
        open={snackbarOpen}
        severity={snackbarSevierty}
        message={snackbarMsg}
        onClose={closeSnackbar}
      ></SnackbarComponent>

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        <Form>
          <div className="mb-3">
            <label htmlFor="userName" className="form-label">
              Name
            </label>
            <Field
              type="text"
              id="userName"
              name="userName"
              className="form-control"
              placeholder="Your Name"
            />
            <ErrorMessage
              name="userName"
              component="div"
              className="text-danger"
            />
          </div>

          <div className="mb-3">
            <label htmlFor="contact" className="form-label">
              Phone Number (WhatsApp)
            </label>
            <Field
              type="text"
              id="contact"
              name="contact"
              className="form-control"
              placeholder="Your Phone Number"
            />
            <ErrorMessage
              name="contact"
              component="div"
              className="text-danger"
            />
          </div>

          <div className="mb-3">
            <label htmlFor="query" className="form-label">
              Query
            </label>
            <Field
              as="textarea"
              id="query"
              name="query"
              className="form-control"
              placeholder="Your Query"
            />
            <ErrorMessage
              name="query"
              component="div"
              className="text-danger"
            />
          </div>

          <button type="submit" className="btn btn-primary">
            Submit Your Query
          </button>
        </Form>
      </Formik>
    </>
  );
};

export default QueryForm;
